import axios from "axios";
import Constants from "variables/Constants";

// Digital OMR — Admin Dashboard endpoints. Admin routes are unprotected per the
// existing admin-route convention, so no auth header is attached (matching the
// app's other admin calls). Base resolves to https://admin.akclasses.in/api/omr.
const BASE = Constants.imgUrl + "api/omr";

// Pull a human-readable message out of a Laravel-style error response:
// { message } or { errors: { field: [msg] } }.
export const omrError = (err, fallback) => {
  const d = err && err.response && err.response.data;
  if (d) {
    if (d.message) return d.message;
    if (d.errors) {
      const first = Object.values(d.errors)[0];
      if (Array.isArray(first) && first[0]) return first[0];
    }
  }
  return fallback || "Something went wrong. Please try again.";
};

const OmrApi = {
  listTestPapers: (params) => axios.get(`${BASE}/test-papers`, { params }),
  getTestPaper: (id) => axios.get(`${BASE}/test-papers/${id}`),
  createTestPaper: (formData) => axios.post(`${BASE}/test-papers`, formData),
  updateTestPaper: (id, formData) =>
    axios.post(`${BASE}/test-papers/${id}`, formData),
  deleteTestPaper: (id) => axios.delete(`${BASE}/test-papers/${id}`),
  publishTestPaper: (id) => axios.post(`${BASE}/test-papers/${id}/publish`),
  // Student reports for a paper: counts + individual results, and the ranking.
  getSubmissions: (id) => axios.get(`${BASE}/test-papers/${id}/submissions`),
  getRanking: (id) => axios.get(`${BASE}/test-papers/${id}/ranking`),
  previewAnswerKey: (formData) =>
    axios.post(`${BASE}/answer-key/preview`, formData),
  saveAnswerKey: (id, answers) =>
    axios.put(`${BASE}/test-papers/${id}/answer-key`, { answers }),

  // ---- Subjects -----------------------------------------------------------
  // with_chapters=1 embeds chapters; 0 returns chapters_count only.
  listSubjects: (params) => axios.get(`${BASE}/subjects`, { params }),
  getSubject: (id) => axios.get(`${BASE}/subjects/${id}`),
  createSubject: (data) => axios.post(`${BASE}/subjects`, data),
  updateSubject: (id, data) => axios.post(`${BASE}/subjects/${id}`, data),
  deleteSubject: (id) => axios.delete(`${BASE}/subjects/${id}`),
  // Chapters belonging to a subject — drives the dependent chapter dropdown.
  listSubjectChapters: (subjectId) =>
    axios.get(`${BASE}/subjects/${subjectId}/chapters`),

  // ---- Chapters -----------------------------------------------------------
  listChapters: (params) => axios.get(`${BASE}/chapters`, { params }),
  createChapter: (data) => axios.post(`${BASE}/chapters`, data),
  updateChapter: (id, data) => axios.post(`${BASE}/chapters/${id}`, data),
  deleteChapter: (id) => axios.delete(`${BASE}/chapters/${id}`),
};

export default OmrApi;
